<pr-icon-chip
  fontSet="material-icons"
  matTooltipPosition="above"
  fontSet="material-symbols"
  [icon]="icon()"
  [matTooltip]="label()"
  [noBorder]="active()"
  [ngClass]="{
    'bg-primary-50 border-primary-100 border border-solid': active()
  }"
>
  {{ values() }}
</pr-icon-chip>
